/**
 * @author Mohit Kukreja <mohit.kukreja@314ecorp.com>
 * @description React Hook useWriteOffPR
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';
import _ from 'lodash';

/**
 * Mutate for write off claim
 */

const useWriteOffPR = (): UseMutationResult<unknown, IAxiosError, ClaimWriteOffRequest, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ claims }) => {
			await api.FHIRClaimApi.postClaimWriteOff({ claimWriteOffRequest: { claims } });
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			// invalidate queries
			_.forEach(
				[
					QUERY_KEYS.claimRequestById,
					QUERY_KEYS.claimStatusRequests,
					QUERY_KEYS.accountClaims,
					QUERY_KEYS.patientInfo,
					QUERY_KEYS.guarantors,
				],
				(queryKey) => {
					queryClient.invalidateQueries({ queryKey: [queryKey] });
				},
			);
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useWriteOffPR;
